import React from "react";
import PropTypes from "prop-types";
import { faCheck, faFileAlt, faHourglassHalf, faTimes } from "@fortawesome/free-solid-svg-icons";
import CountIcon from "./CountIcon";
import "./StatusBar.scss";
import { Col, Row } from "reactstrap";
const icons = [
  {
    status: "total",
    icon: faFileAlt,
    color: "#303fa1",
  },
  {
    status: "signed",
    icon: faCheck,
    color: "#219653",
  },
  {
    status: "rejected",
    icon: faTimes,
    color: "#eb5757",
  },
  {
    status: "waiting",
    icon: faHourglassHalf,
  },
];
export const getStatusIcon = (value) => icons.find((i) => value === i.status);

/**
 * StatusBar.
 */
const StatusBar = ({ items }) => {
  return (
    <Col className="status-bar">
      <Row noGutters className="flex-row">
        {Object.entries(items).map(([key, value]) => {
          const icon = getStatusIcon(value.status);
          return (
            <Col className="pl-4 pr-4 status-item">
              <CountIcon
                onClick={value.onClick}
                title={value.title}
                icon={icon.icon}
                color={icon.color}
                count={value.count}
              />
            </Col>
          );
        })}
      </Row>
    </Col>
  );
};

StatusBar.propTypes = {
  items: PropTypes.array.isRequired,
};
export default StatusBar;
